import React from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import BarChart from '../../Charts/BarChart';
import TableToggle from '../TableToggle';
import { Col, Row } from 'react-bootstrap';
import { fixCIP, colors } from '../../../utilities/formats';
import KeyValueData from '../../Charts/KeyValueData';
import useTableToggle from '../../Hooks/useTableToggle';
import NoData from '../NoData';


export default function ResearchDoctorates({ institutionData }) {
    const { table, handleTable } = useTableToggle();
    const title = 'Research Doctorates';

    const total = institutionData.post_meta.rd_total_count.value;

    if (!total) {
        return <NoData widgetTitle={title} />;
    }

    const slots = 10;
    const doctorates = [];
    for (let i = 1; i <= slots; i++) {
        const field = 'rd_name_' + i;
        const count = 'rd_count_' + i;
        if (institutionData.post_meta[count].value) {
            doctorates.push({
                label: fixCIP(institutionData.post_meta[field].value),
                value: parseInt(institutionData.post_meta[count].value),
            });
        }
    }

    if (institutionData.post_meta.rd_remainder_count.value) {
        doctorates.push({
            label: institutionData.post_meta.rd_remainder_name.value,
            value: institutionData.post_meta.rd_remainder_count.value,
        })
    }

    return (
        <Widget className="research-doctorates">

            <Row gap={5} gap-lg={0} className='mb-4'>
                <Col xs={12} sm={9} className='d-flex align-items-center'>
                    <img src="/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/widgets/research-activity-designation/icon-research-doctorates.svg"
                        alt="Research Activity Designation" className='me-2' width="50" height="50" />

                    <WidgetTitle className="mb-0">{title}</WidgetTitle>
                </Col>
                <Col xs={12} sm={3} className='d-flex align-items-center justify-content-end'>
                    <TableToggle handleTable={handleTable} table={table} />
                </Col>
            </Row>
            <p><strong>Total Research Doctorates:</strong> {total}</p>
            <p>Research Doctorates by Program:</p>
            {!table ?
                doctorates.map((doctorate, i) => {
                    return (
                        <div className='my-2' key={i}>
                            <BarChart data={doctorate} total={total} color={colors.blue} />
                        </div>
                    );
                })
                : <KeyValueData data={doctorates} />}
        </Widget >
    );
}